import { darkTheme, lightTheme } from "@yleisradio/yds-core";

export const audioPlayerLightThemeVolumeBarBackgroundColor =
  "rgba(216, 217, 219, 0.7)";
export const audioPreviewButtonDisabledDarkThemeBackgroundColor =
  darkTheme.BACKGROUND_CONTROL_DISABLED;
export const audioPreviewButtonDisabledDarkThemeColor = darkTheme.TEXT_DISABLED;
export const audioPreviewButtonDisabledLightThemeBackgroundColor =
  lightTheme.BACKGROUND_CONTROL_DISABLED;
export const audioPreviewButtonDisabledLightThemeColor =
  lightTheme.TEXT_DISABLED;
export const controlsTextColor = darkTheme.TEXT_DEFAULT;
export const darkThemeBackgroundInteractive = darkTheme.BACKGROUND_INTERACTIVE;
export const darkThemeBufferBackgroundColor = darkTheme.BACKGROUND_INFO_PRIMARY;
export const darkThemeColor = darkTheme.TEXT_NEGATIVE;
export const darkThemeHoverColor = "rgba(255, 255, 255, 0.9)";
export const darkThemeProgressBarBackgroundColor = "rgba(216, 217, 219, 0.17)";
export const darkThemeShareLinkHoverBackgroundColor =
  "rgba(255, 255, 255, 0.2)";
export const darkThemeTextColor = darkTheme.TEXT_DEFAULT;
export const focusColor = darkTheme.BORDER_PRIMARY_FOCUS;
export const lightThemeBackgroundInteractive =
  lightTheme.BACKGROUND_INTERACTIVE;
export const lightThemeBufferBackgroundColor = "#949697";
export const lightThemeColor = lightTheme.TEXT_NEGATIVE;
export const lightThemeHoverColor = lightTheme.TEXT_MEDIUM_EMPHASIS;
export const lightThemeProgressBarBackgroundColor = "rgba(0, 0, 0, 0.015)";
export const lightThemeProgressBarElapsedColor = lightTheme.FEEDBACK_HIGHLIGHT;
export const lightThemeShareLinkHoverBackgroundColor = "rgba(0, 0, 0, 0.09)";
export const lightThemeTextColor = lightTheme.TEXT_DEFAULT;
export const nextEpisodeBackgroundColor = "rgba(0, 0, 0, .6)";
export const nextEpisodeInfoColor = darkTheme.TEXT_DEFAULT;
export const nextEpisodeTimerColor = "#f5cf89";
export const playButtonBackgroundColor = "#11b4c7";
export const playButtonDarkBackgroundColor = "#038b98";
export const progressBarBackgroundColor = "rgba(255, 255, 255, 0.17)";
export const progressBarBufferColor = darkTheme.PLAYER_PROGRESS_BAR;
export const progressBarDisabledColor = "#B4B6B7";
export const progressBarElapsedColor = darkTheme.FEEDBACK_HIGHLIGHT;
export const progressBarHoverColor = "rgba(255, 255, 255, 0.98)";
export const progressBarLiveElapsedColor = darkTheme.FEEDBACK_LIVE;
export const recommendationTextColor = darkTheme.TEXT_DEFAULT;
export const shareOverlayEmbedCodeColor = "#10a4b4";
export const textLineHeight = "1.4";
export const videoFontColorOnScreen = darkTheme.TEXT_DEFAULT;
export const videoPreviewBackgroundColor = darkTheme.BACKGROUND_DIALOG_OVERLAY;
export const videoPreviewGradientFrom = "#1f2224";
export const videoPreviewGradientTo = "rgba(31, 34, 36, 0)";
export const videoPreviewTitleColor = darkTheme.TEXT_DEFAULT;
export const videoPreviewTitleFontSize = "17px";
